import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/politica-de-cookies")({
  head: () => ({
    meta: [
      { title: "Política de Cookies - P2 PRO | Experiência de Navegação Segura" },
      { name: "description", content: "Entenda como a P2 PRO utiliza cookies para melhorar sua navegação e personalizar sua experiência no site e no painel gerencial." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="POLÍTICA DE COOKIES: NAVEGAÇÃO OTIMIZADA"
      subtitle="Saiba como pequenos arquivos ajudam a tornar seu acesso à P2 PRO mais rápido e personalizado."
      introParagraphs={[
        "Cookies são pequenos arquivos de texto que são armazenados no seu dispositivo quando você visita um site. Eles são amplamente utilizados para fazer com que os sites funcionem ou operem de maneira mais eficiente, bem como para fornecer informações aos proprietários do site.",
        "Na P2 PRO, utilizamos cookies para garantir que nosso site e nosso painel administrativo funcionem corretamente, permitindo que você permaneça logado de forma segura e que suas preferências de navegação sejam lembradas a cada nova visita.",
        "Nossa Política de Cookies detalha quais tipos de cookies utilizamos, para qual finalidade e como você pode gerenciar suas preferências de privacidade diretamente no seu navegador, garantindo total transparência no uso dessas tecnologias."
      ]}
      benefits={[
        {
          title: "Sessão Segura",
          description: "Cookies que garantem que apenas você tenha acesso à sua área administrativa logada.",
        },
        {
          title: "Preferências de Uso",
          description: "Lembrança de idioma, filtros de busca e visualização que você configurou no painel.",
        },
        {
          title: "Performance de Carregamento",
          description: "Otimização de arquivos estáticos para que o site carregue muito mais rápido no seu celular.",
        }
      ]}
      howItWorks={[
        { title: "Armazenamento", description: "O cookie é enviado pelo nosso servidor e guardado no navegador do seu dispositivo." },
        { title: "Reconhecimento", description: "Na sua próxima visita, o navegador envia o cookie de volta para que o site te identifique." },
        { title: "Temporários", description: "Alguns cookies expiram assim que você fecha o navegador (cookies de sessão)." },
        { title: "Persistentes", description: "Outros permanecem por um tempo determinado para lembrar de você (cookies persistentes)." }
      ]}
      diferenciais={[
        { title: "Zero Cookies Invasivos", description: "Não utilizamos cookies para rastreamento de comportamento fora do nosso domínio." },
        { title: "Segurança de Terceiros", description: "Integração apenas com cookies de serviços essenciais como Cloudflare e Google Analytics." },
        { title: "Gerenciamento Simplificado", description: "Instruções claras de como desativar cookies se assim você desejar." }
      ]}
      faq={[
        {
          question: "Sou obrigado a aceitar os cookies?",
          answer: "Não, mas algumas funcionalidades essenciais do painel de revendedor podem não funcionar sem eles."
        },
        {
          question: "Cookies transmitem vírus?",
          answer: "Não. Cookies são apenas arquivos de texto que não podem executar programas ou instalar malwares."
        },
        {
          question: "Como limpo meus cookies?",
          answer: "Você pode fazer isso a qualquer momento nas configurações de 'Privacidade e Segurança' do seu navegador (Chrome, Safari, Firefox, etc.)."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "Cookies", href: "/politica-de-cookies" }
      ]}
    />
  ),
});
